import { PropsWithChildren, ReactElement } from 'react';

import { IonGrid } from '@ionic/react';

import { GridRow } from './GridRow/GridRow';
import { GridCol } from './GridCol/GridCol';

export type GridProps = PropsWithChildren<{}>;

interface GridComponent {
  (props: GridProps): ReactElement;
  Row: typeof GridRow;
  Col: typeof GridCol;
}

export const Grid: GridComponent = ({ children }) => {
  return <IonGrid>{children}</IonGrid>;
};

Grid.Row = GridRow;
Grid.Col = GridCol;
